import CONFIG_PROD from "@iso/config/site.config.production";
import CONFIG_DEV from "@iso/config/site.config.development";

import axios from "axios";
import authAction from "@iso/redux/auth/actions";
import { store } from "../../redux/store";
const { logout } = authAction;

const CONFIG =
  process.env.NODE_ENV === "production" ? CONFIG_PROD : CONFIG_DEV;

const API = {
  login: async (body) =>
    axios
      .post(`${CONFIG.apiUrl}login`, body)
      .then((result) => result)
      .catch((error) => error.response),

  register: async (body) =>
    axios
      .post(`${CONFIG.apiUrl}register`, body)
      .then((result) => result)
      .catch((error) => error.response),

  confirmEmail: async (email, code) =>
    axios
      .get(`${CONFIG.apiUrl}email-confirmation/${email}/${code}`)
      .then((result) => result)
      .catch((error) => error.response),

  userInfo: async (token) =>
    axios({
      url: `${CONFIG.apiUrl}user`,
      method: "GET",
      headers: { "x-access-token": token },
    })
      .then((response) => response)
      .catch((error) => error.response),

  updateUserInfo: async (payload, token) =>
    axios({
      url: `${CONFIG.apiUrl}user`,
      data: payload,
      method: "PUT",
      headers: { "x-access-token": token },
    })
      .then((response) => response)
      .catch((error) => error.response),

  updatePartnerInfo: async (payload, token) =>
    axios({
      url: `${CONFIG.apiUrl}partner`,
      data: payload,
      method: "PUT",
      headers: { "x-access-token": token },
    })
      .then((response) => response)
      .catch((error) => error.response),

  updateUserPassword: async (payload, token) =>
    axios({
      url: `${CONFIG.apiUrl}user/password`,
      data: payload,
      method: "PUT",
      headers: { "x-access-token": token },
    })
      .then((response) => response)
      .catch((error) => error.response),

  getSettings: async (key) =>
    axios
      .get(`${CONFIG.apiUrl}settings`, { headers: { "key": key } })
      .then((response) => response)
      .catch((error) => error.response),

  updateProductionPartnerKey: async (payload, token) =>
    axios({
      url: `${CONFIG.apiUrl}partner/credentials/production`,
      data: { ...payload, environment: "production" },
      method: "POST",
      headers: { "x-access-token": token },
    }).then((response) => response),

  updateSandboxPartnerKey: async (payload, token) =>
    axios({
      url: `${CONFIG.apiUrl}partner/credentials/sandbox`,
      data: { ...payload, environment: "sandbox" },
      method: "POST",
      headers: { "x-access-token": token },
    }).then((response) => response),

  setSettings: async (payload, token) =>
    axios({
      url: `${CONFIG.apiUrl}user/settings`,
      data: payload,
      method: "PUT",
      headers: { "x-access-token": token },
    })
      .then((response) => response)
      .catch((error) => error.response),

  setSettingsPartially: async (payload, token) =>
    axios({
      url: `${CONFIG.apiUrl}user/settings`,
      data: payload,
      method: "PATCH",
      headers: { "x-access-token": token },
    })
      .then((response) => response)
      .catch((error) => error.response),

  listTransactions: async (token, environment) =>
    axios
      .get(`${CONFIG.apiUrl}user/transactions?environment=${environment}`, {
        headers: { "x-access-token": token },
      })
      .then((response) => response)
      .catch((error) => error.response),

  listTransactionsStats: async (token) =>
    axios
      .get(`${CONFIG.apiUrl}user/transactions/stats`, {
        headers: { "x-access-token": token },
      })
      .then((response) => response)
      .catch((error) => error.response),

  listUserPayments: async (token) =>
    axios
      .get(`${CONFIG.apiUrl}user/payments`, {
        headers: { "x-access-token": token },
      })
      .then((response) => response)
      .catch((error) => error.response),

  getUserNotifications: async (token) =>
    axios
      .get(`${CONFIG.apiUrl}user/notifications`, {
        headers: { "x-access-token": token },
      })
      .then((response) => response)
      .catch((error) => error.response),

  sendResetPasswordCode: async (email) =>
    await axios
      .post(`${CONFIG.apiUrl}reset-password/${email}`)
      .then((result) => result.data),

  sendCodeAgain: async (email) =>
    await axios
      .get(`${CONFIG.apiUrl}res-send-email-confirmation/${email}`)
      .then((result) => result)
      .catch((error) => error.response),

  query: async (url) =>
    await axios
      .get(url, {
        headers: { "x-access-token": localStorage.getItem("id_token") },
      })
      .then((res) => res)
      .catch((error) => {
        if (error && error.response && error.response.status === 401) {
          return store.dispatch(logout());
        } else {
          return error;
        }
      }),
};

export default API;
